export default __webpack_public_path__ + "static/media/limpeza.10516cca.jpg";